import { ACTIONS_FROM_UNIFIED_INBOX, UNIFIED_INBOX_PERMISSIONS } from '../../constants';
import { decodeUnescapedStr } from '../../js/helpers/Utils/formats';
import { removeFromObject, updateArrayImmutably } from 'global-components-library';

const initialUnifiedInboxState = {
	conversations: {
		0:{},
		1:{}
	},
	showWrapUp: false,
	wrapUpTime: 0,
	show: false,
	selected: {campType: undefined, convId: undefined},
	lastConversation: {campType: undefined, convId: 0},
	selectedData: undefined,
	errorMMC: undefined,
	convsDeletedByError: [],
	campTypeConvsDeletedByError: undefined,
	draftMessages: {}
};


const getNewDictionary = (dictionary, campType, id, data, isNewMessage) => {
	if((isNewMessage && campType != null && id) || (campType != null && id && dictionary[campType][id])){
		return {
			...dictionary,
			[campType]:{
				...dictionary[campType],
				[id]:{
					...dictionary[campType][id],
					...data
				}
			}
		}
	}
	return dictionary
}

const removeConversation = (conversations, campType, id) => ({
	...conversations,
	[campType]: removeFromObject(conversations[campType], id)
})

const unifiedInboxState = (state = initialUnifiedInboxState, action) => {
	switch (action.type) {
		case ACTIONS_FROM_UNIFIED_INBOX.SHOW:
			return {
				...state,
				show: action.show
			};
		case ACTIONS_FROM_UNIFIED_INBOX.NEW_CONVERSATION[0]:
		case ACTIONS_FROM_UNIFIED_INBOX.NEW_CONVERSATION[1]:
		case ACTIONS_FROM_UNIFIED_INBOX.NEW_CONVERSATION[2]:
		case ACTIONS_FROM_UNIFIED_INBOX.NEW_CONVERSATION[3]:
			const newConversation = {
				id: action.conversationId,
				type: action.type,
				totalTime: 0, 
				initialTime: action.initialTime,
				messages: [],
				typing: false,
				takeover: false,
				clientTermination: false,
				IsAzure: action.IsAzure ? action.IsAzure : false,
				contact: {
					name: action.name,
					account: action.account,
					photo: action.photo
				},
				campaign: {
					id: action.acdId,
					name: action.acdName,
					graphicId: action.GraphicId,
					account: action.accountMail,
					timeoutWarning: action.timeoutWarning,
					timeout: action.timeout,
					senderName: action.senderName,
					type: action.campType,
					dispositions: [
						{ id: 1, text: 'exitoso' },
						{ id: 2, text: 'inconcluso' },
						{ id: 3, text: 'transferido' }
					],
					wrapUpTime: (action.wrapUpTime * 1000)
				},
				campType: action.campType
			};

			if (action.content) {
				newConversation.messages = action.content.map(function (i) {
					return {
						id: i.MessageID,
						content: i.Message,
						origin: action.origin,
						date: i.MsgTimestamp,
						subject: i.EmailSubject,
						media: action.media,
						seen: i.ExistedMessage,
						attachments: i.Attachments,
						campType: i.CampType,
						graphicId: i.GraphicId
					};
				});
			}

			if (action.TwitterMessagesList) {
				newConversation.campaign.image = action.TwitterMessagesList[0].CreatedByImage;
				newConversation.messages = action.TwitterMessagesList.map(tweet => ({
					profileImage: tweet.CreatedByImage,
					content: tweet.Message,
					id: tweet.MessageID,
					media: tweet.Medias,
					date: new Date(tweet.CreatedAt)
				}));
			}
			return {
				...state,
				showWrapUp: action.showWrapUp,
				wrapUpTime: action.wrapUpTime,
				conversations: getNewDictionary(state.conversations, action.campType, action.conversationId, newConversation, true)
			};
		case ACTIONS_FROM_UNIFIED_INBOX.EXTERNAL_MESSAGING_CUSTOMER:
			const newExternalMediaConversation = {
				id: action.conversationId,
				type: action.serviceType,
				totalTime: action.totalTime,
				initialTime: action.initialTime,
				messages: [],
				takeover: false,
				clientTermination: action.clientTermination,
				IsAzure: action.IsAzure ? action.IsAzure : false,
				exitWrapUpDisposition: action.campaign.ExitWrapUpDisposition,
				unreadMessage: true,
				statusConversation: action.SecTimeOutLastMessageAgent ? 'AGENT_READY' : 'NewConversation',
				SecTimeOutLastMessageAgent: action.SecTimeOutLastMessageAgent ?  action.SecTimeOutLastMessageAgent : null,
				chatStarted: action.SecTimeOutLastMessageAgent || action.campaign.Type === 1 ? true: false,
				contact: {
					name: action.name,
					from:action.from ? action.from : '',
					to:action.to ? action.to : ''
					// account: action.account,
					// photo: action.photo
				},
				campaign: {
					id: action.campaign.ACDId ? action.campaign.ACDId : action.campaign.Id,
					name: action.campaign.ACDName ? action.campaign.ACDName : action.campaign.Name,
					graphicId: action.campaign.GraphicId,
					timeout: action.campaign.TimeOut * 60,
					timeoutWarning: action.campaign.TimeOut * 60 * (3/4),
					wrapUpTime: action.campaign.WrapUpTime * 1000,
					showWrapUp: action.showWrapUp,
					dispositions: [],
					type: action.campaign.Type
				},
				allowUnassign: action.allowUnassign,
				allowSpam: action.allowSpam,
				clientWithHistoricalChat: action.lastConversations.IsClientWithHistoricalChat,
				campType: action.campaign.Type,
				lastConversations: {
					lastIdSearched: action.lastConversations.LastConversationIdSearched,
					lastIdCampType: action.lastConversations.LastConversationIdCampType,
					conversationsDict: [...(action.lastConversations.InboundConversationIds || []), ...(action.lastConversations.OutboundConversationIds || [])],
					isAllConversations: action.lastConversations.IsAllConversations,
					fetching: undefined
				}
			};
			if (action.content) {
				newExternalMediaConversation.messages = action.content.map(function (i) {
					return {
						id: i.Message_IdUI != null ? i.Message_IdUI : i.MessageId == null ? 1 : i.MessageId,
						messageId: i.MessageId != null ? i.MessageId : 1,
						conversationId: i.ConversationID ? i.ConversationID : 0,
						origin: i.OriginType === 1 ? 'ADMIN' : i.OriginType === 2 ? 'AGENT' : 'USER',
						originName: i.OriginName != null ? i.OriginName : null,
						fromAgent: i.FromAgent != null ? i.FromAgent : null,
						status: i.Status,
						date: i.Date ? i.Date : i.Timestamp ? new Date(i.Timestamp) : new Date(),
						content: i.Content,
						type: i.Type ? i.Type : 'text',
						attachments: {
							Caption: i.Attachments != null && i.Attachments.Caption != null ? i.Attachments.Caption : '',
                            Url: i.Attachments != null && i.Attachments.Url != null ? i.Attachments.Url.replace(/\\/g, '/').replace(/ /g, '%20') : '',
                            Name: i.Attachments ? i.Attachments.FileName : undefined,
                            Size: i.Attachments ? i.Attachments.FileSize : undefined
						},
						location: i.Location != null ? i.Location : '',
						seen: false,
						campType: i.CampType,
						graphicId: i.GraphicId
					};
				});
			}
			if (action.campaign.Dispositions) {
				newExternalMediaConversation.campaign.dispositions = Object.values(action.campaign.Dispositions).map(disposition => ({
					id: disposition.Id,
					text: disposition.Description,
					endConversation: disposition.EndConversation,
					subDispositions: Array.isArray(disposition.SubDisposition)
						? disposition.SubDisposition.map(sub => ({
								...sub,
								id: sub.Id,
								text: sub.Description,
								endConversation: sub.EndConversation
						  }))
						: Object.keys(disposition.SubDisposition).length === 0
						? undefined
						: Object.values(disposition.SubDisposition).map(sub => ({
								...sub,
								id: sub.Id,
								text: sub.Description,
								endConversation: sub.EndConversation
						  }))
				}));
			}

			return {
				...state,
				showWrapUp: action.showWrapUp,
				wrapUpTime: action.campaign.WrapUpTime * 1000,
				conversations: getNewDictionary(state.conversations, newExternalMediaConversation.campType, action.conversationId, newExternalMediaConversation, true)
			};
		case ACTIONS_FROM_UNIFIED_INBOX.MULTIMEDIA_MESSAGE_ERROR_MMC:
				let attendedConversations = {};
				for(const campType in state.conversations){
					for(const convId in state.conversations[campType] )
					if(state.conversations[campType][convId].chatStarted || state.conversations[campType][convId].type !== "WHATSAPP"){
						attendedConversations[campType][convId] = state.conversations[campType][convId];
					}
				}
				return {
					...state,
					errorMMC: action.value,
					conversations: action.value ? attendedConversations : state.conversations
				};
		case ACTIONS_FROM_UNIFIED_INBOX.TYPING:
			if (state.conversations[action.campType][action.conversationId]) {
				return {
					...state,
					conversations: getNewDictionary(state.conversations, action.campType, action.conversationId, {typing: action.typing})
				}
			} else {
				return state;
			}
		case ACTIONS_FROM_UNIFIED_INBOX.SELECT_CONVERSATION:
			return {
				...state,
				selected: {campType: action.campType, convId: action.selectedID}
			};
		case ACTIONS_FROM_UNIFIED_INBOX.ACEPTED_CHAT:
			return{
				...state,
				conversations: getNewDictionary(
					state.conversations, 
					state.selected.campType, 
					state.selected.convId, 
					{
						chatStarted: true,
						initialTime: new Date()
					}
				)
			}
		case ACTIONS_FROM_UNIFIED_INBOX.END_CONVERSATION:
			if (!action.data.ShowWrapUp && action.data.MediaType > 4) {
				return { ...state, conversations: removeConversation(state.conversations, action.data.CampType, action.data.ConversationId)};
			}
			if (state.lastConversation.campType != null && state.conversations[state.lastConversation.campType][state.lastConversation.convId]) {
				return { ...state, lastConversation:{campType: undefined, convId: 0}, conversations: removeConversation(state.conversations, action.data.CampType, action.data.ConversationId)};
			}
			return { ...state, lastConversation: {campType: action.data.CampType, convId: action.data.ConversationId}};

		case ACTIONS_FROM_UNIFIED_INBOX.SPAM_CONVERSATION:
			return { ...state, lastConversation:{campType: undefined, convId: 0}, conversations: removeConversation(state.conversations, action.data.campType, action.data.conversationId) };

		case ACTIONS_FROM_UNIFIED_INBOX.UNASSIGN_CONVERSATION:
			return { ...state, lastConversation: {campType: undefined, convId: 0}, conversations: removeConversation(state.conversations, action.data.campType, action.data.conversationId) };

		case ACTIONS_FROM_UNIFIED_INBOX.DISCARD_CONVERSATION:
			return { ...state, conversations: removeConversation(state.conversations, action.data.campType, action.data.conversationId) };

		// case ACTIONS_FROM_UNIFIED_INBOX.SEND_UNIFIED_RESPONSE:
		// 	if (action.data.MediaType === 2) {
		// 		return { ...state, conversations: removeConversation(state.conversations, action.data.CamType, action.data.ConversationId) };
		// 	} else {
		// 		return state;
		// 	}
		// case MESSAGES_TO_SM.SEND_DISPOSITION:
		// 	if (action.data.closeModal) {
		// 		const currentconversation = state.conversations[action.data.conversationId];
		// 		if (currentconversation.type === 'CHAT') {
		// 			const { [action.data.conversationId]: temp6, ...newConversations6 } = state.conversations;
		// 			delete newConversations6[action.data.conversationId];
		// 			return { ...state, lastIdConversationEnd: 0, conversations: newConversations6 };
		// 		}
		// 	}
		// 	return { ...state }; 

		case ACTIONS_FROM_UNIFIED_INBOX.CHAT_CUSTOMER_TERMINATION:
			const conversation = state.conversations[action.campType][action.conversationId];
			if (conversation && !conversation.clientTermination) {
				return { ...state, conversations: removeConversation(state.conversations, action.campType, action.conversationId) };
			} else {
				return { ...state };
			}

		case ACTIONS_FROM_UNIFIED_INBOX.NEW_MESSAGE_INBOX[0]:
		case ACTIONS_FROM_UNIFIED_INBOX.NEW_MESSAGE_INBOX[1]:
		case ACTIONS_FROM_UNIFIED_INBOX.NEW_MESSAGE_INBOX[2]:
		case ACTIONS_FROM_UNIFIED_INBOX.NEW_MESSAGE_INBOX[3]: {
			const newMessage = {
				conversationId: action.conversationId,
				content: action.content,
				origin: action.origin,
				date: action.date,
				subject: action.subject,
				type: action.media.toLowerCase(),
				attachments: action.media.toLowerCase() !== "text" ? {
					Caption: '',
					Url: action.content.replace("\\", "/")
				}: null,
				seen: action.origin !== 'AGENT' && action.conversationId !== state.selected.convId ? false : true,
				campType: action.CampType,
				graphicId: action.GraphicId
			};
			return {
				...state,
				conversations: getNewDictionary(state.conversations, action.campType, action.conversationId, {messages: [...state.conversations[action.campType][action.conversationId].messages, newMessage]})
			};
			
		}
		case ACTIONS_FROM_UNIFIED_INBOX.EXTERNAL_NEW_MESSAGING:
			const newMessage = Array.isArray(action.messagesList)
				? action.messagesList.map(e => ({
						id: e.Message_IdUI,
						content: e.Content,
						date: new Date(),
						origin: e.OriginType === 1 ? 'ADMIN' : e.OriginType === 2 ? 'AGENT' : 'USER',
						originName: e.OriginName != null ? e.OriginName : null,
						fromAgent: e.FromAgent != null ? e.FromAgent : null,
						status: e.Status ? e.Status : 'send',
						type: e.Type ? e.Type : 'text',
						attachments: e.Attachments,
						location: e.Location,
						conversationId: e.ConversationID ? e.ConversationID : 0,
						campType: action.campType,
						graphicId: action.graphicId
				  }))[0]
				: {
						id: action.messageId,
						content: action.content,
						date: action.date,
						origin: action.origin === 1 ? 'ADMIN' : action.origin === 2 ? 'AGENT' : 'USER',
						originName: action.OriginName != null ? action.OriginName : null,
						fromAgent: action.FromAgent != null ? action.FromAgent : null,
						status: action.status,
						type: action.MessageType,
						attachments: action.Attachments,
						conversationId: action.conversationId,
						campType: action.campType,
						graphicId: action.graphicId
				  };
			return {
				...state,
				conversations: getNewDictionary(
					state.conversations, 
					action.campType, 
					action.conversationId, 
					{
						unreadMessage: action.conversationId === state.selected.convId || action.origin === 2 ? false : true, 
						messages: [...state.conversations[action.campType][action.conversationId].messages, newMessage]
					}
				)
			};
		case 'CHANGE_STATE_EXTERL_MESSAGE':
			return {
				...state,
				conversations: getNewDictionary(state.conversations, action.campType, action.conversationId, {unreadMessage: action.unreadMessage})
			};
		case ACTIONS_FROM_UNIFIED_INBOX.CHAT_TAKEOVER:
			if (state.conversations[action.conversationId]) {
				return {
					...state,
					conversations: getNewDictionary(state.conversations, action.campType, action.conversationId, {takeover: action.takeover})
				};
			} else {
				return state;
			}

		case ACTIONS_FROM_UNIFIED_INBOX.ANSWERS_TEMPLATES_CHAT:
			const newTemplates = action.answers.map(answer => ({ title: decodeUnescapedStr(answer.description), text: decodeUnescapedStr(answer.message), id: answer.message_id }));
			return {
				...state,
				conversations: getNewDictionary(state.conversations, action.campType, action.conversationId, {templates: newTemplates, maxImgChat: action.maxImgChat})
			};
		case ACTIONS_FROM_UNIFIED_INBOX.LOGOUT:
			state = initialUnifiedInboxState;
			return { ...state };
		case ACTIONS_FROM_UNIFIED_INBOX.MULTIMEDIA_DISPOSITION:
			const dispositions = Object.values(action.dispositions).map(disposition => ({
				...disposition,
				id: disposition.Id,
				text: disposition.Description,
				endConversation: disposition.EndConversation,
				subDispositions:
					Object.keys(disposition.SubDisposition).length === 0
						? undefined
						: Object.values(disposition.SubDisposition).map(sub => ({
								...sub,
								id: sub.Id,
								text: sub.Description,
								endConversation: sub.EndConversation
						  }))
			}));
			return {
				...state,
				conversations: getNewDictionary(state.conversations, action.campType, action.conversationId, {campaign: {...state.conversations[action.campType][action.conversationId].campaign, dispositions}})
			};

		case ACTIONS_FROM_UNIFIED_INBOX.CHAT_CLIENT_DISCONNECT:
			if (state.conversations[action.campType][action.conversationId]) {
				return {
					...state,
					conversations: getNewDictionary(state.conversations, action.campType, action.conversationId, {clientTermination: action.clientTermination})
			};
			} else {
				return state;
			}
		case 'MULTIMEDIA_MESSAGE_STATUS':
			if(state.conversations[action.campType][action.conversationId]){
                const { messages } = state.conversations[action.campType][action.conversationId];
                const index = messages.findIndex(i => i.id === parseInt(action.messageId) && i.conversationId === action.conversationId);
                const msg = messages[index];
                return {
                    ...state,
                    conversations: getNewDictionary(
                        state.conversations,
                        action.campType,
                        action.conversationId,
                        {
                            messages: updateArrayImmutably(
                                messages,
                                index,
                                { ...msg, status: msg.status !== 'read' ? action.status : 'read', messageId: action.messageId }
                            )
                        })
                };
			}
			return state;
		case ACTIONS_FROM_UNIFIED_INBOX.CHANGE_STATE_MULTIMEDIA:
			state.selectedData = action.data;
			if (action.data.onReady) {
				return {
					...state,
					conversations: getNewDictionary(state.conversations, action.data.CamType, action.data.ConversationId, {statusConversation: 'AGENT_READY'})
				};
			} else return state;
		case ACTIONS_FROM_UNIFIED_INBOX.CHANGE_STATE_MULTIMEDIA_ALL:
			return {
				...state,
				selectedData: action.data
			}
		case ACTIONS_FROM_UNIFIED_INBOX.CHANGE_STATE:
			if (state.conversations && state.selected.convId && state.selected.campType != null && state.conversations[state.selected.campType][state.selected.convId]  && action.currentState) {
				return {
					...state,
					conversations: getNewDictionary(state.conversations, state.selected.campType, state.selected.convId, {statusConversation: action.currentState})
				};
			} else return state;
		case ACTIONS_FROM_UNIFIED_INBOX.CONVERSATION_TIMEOUT_REACHED:
			if(state.conversations && state.conversations[action.campType][action.conversationId]){
				return {
					...state,
					conversations: getNewDictionary(state.conversations, action.campType, action.conversationId, {timeoutReached: true})
				};
			} else return state;
		case ACTIONS_FROM_UNIFIED_INBOX.END_CONVERSATIONS_CAMPAIGN_DELETED:
			if(state.conversations && action.conversationIds && action.campType != null){
				const actionConvs = action.conversationIds.split(',');
				return {...state, convsDeletedByError: actionConvs, campTypeConvsDeletedByError: action.campType}
			} else return state;
		case ACTIONS_FROM_UNIFIED_INBOX.UPDATE_CONVS_DELETED_BY_ERROR:
			if(state.convsDeletedByError && state.convsDeletedByError.length > 0 && state.campTypeConvsDeletedByError != null){
				let newConversations = {...state.conversations};
				delete newConversations[state.campTypeConvsDeletedByError];
				newConversations[state.campTypeConvsDeletedByError]={};
				for(let key in state.conversations[state.campTypeConvsDeletedByError]){
					if(!state.convsDeletedByError.includes(key)){
						newConversations[state.campTypeConvsDeletedByError] = {
							...newConversations[state.campTypeConvsDeletedByError],
							[key]: state.conversations[state.campTypeConvsDeletedByError][key]
						}
					}
				}
				return {...state, conversations: newConversations, convsDeletedByError: [], campTypeConvsDeletedByError: undefined}
			} else return state;
		case ACTIONS_FROM_UNIFIED_INBOX.NEW_HISTORICAL_CONVERSATION:
			if(state.conversations && state.conversations[action.campType][action.conversationId]){
				const newHistoricalConversation = action.lastConversation.Messages.map(e => ({
							id: e.Message_IdUI,
							conversationId: e.ConversationID ? e.ConversationID : 0,
							content: e.Content,
							date: e.Date ? e.Date : e.Timestamp ? Date.parse(e.Timestamp) : new Date(),
							origin: e.OriginType === 1 ? 'ADMIN' : e.OriginType === 2 ? 'AGENT' : 'USER',
							originName: e.OriginName != null ? e.OriginName : null,
							fromAgent: e.FromAgent != null ? e.FromAgent : null,
							status: e.Status ? e.Status : 'send',
							type: e.Type ? e.Type : 'text',
							attachments: {
								Caption: e.Attachments != null && e.Attachments.Caption != null ? e.Attachments.Caption : '',
								Url: e.Attachments != null && e.Attachments.Url != null ? e.Attachments.Url.replace(/\\/g, '/').replace(/ /g, '%20') : ''
							},
							location: e.Location != null ? e.Location : '',
							campType: e.campType,
							graphicId: e.graphicId
							
						}))
				return {
					...state,
					// conversations: {
					// 	...state.conversations,
					// 	[action.conversationId]: {
					// 		...state.conversations[action.conversationId],
					// 		messages: [...newHistoricalConversation, ...state.conversations[action.conversationId].messages],
					// 		lastConversations: {
								// ...state.conversations[action.conversationId].lastConversations,
								// lastIdSearched: action.lastConversationId,
								// isAllConversations: action.lastConversationId === state.conversations[action.conversationId].lastConversations.conversationsDict[0].ConversationId ? true : false,
								// fetching: false
					// 		}
					// 	}
					// }
					conversations: getNewDictionary(
						state.conversations, 
						action.campType, 
						action.conversationId, 
						{
							messages: [...newHistoricalConversation, ...state.conversations[action.campType][action.conversationId].messages],
							lastConversations: {
								...state.conversations[action.campType][action.conversationId].lastConversations,
								lastIdSearched: action.lastConversationId,
								lastIdCampType: action.lastConversation.LastConversations.LastConversationIdCampType,
								isAllConversations: action.lastConversation.LastConversations.IsAllConversations,
								fetching: false
							}
						}
					)
				};
			} else return state;
		case ACTIONS_FROM_UNIFIED_INBOX.ERROR_HISTORICAL_CONVERSATION:
			if (state.conversations && state.conversations[action.campType][action.conversationId]) {
				return {
					...state,
					// conversations: {
					// 	...state.conversations,
					// 	[action.conversationId]: {
					// 		...state.conversations[action.conversationId],
					// 		lastConversations: {
					// 			...state.conversations[action.conversationId].lastConversations,
					// 			isAllConversations: action.lastConversationId === state.conversations[action.conversationId].lastConversations.conversationsDict[0].ConversationId ? true : false,
					// 			lastIdSearched: action.lastConversationId,
					// 			fetching: false
					// 		}
					// 	}
					// }
					conversations: getNewDictionary(
						state.conversations, 
						action.campType, 
						action.conversationId, 
						{
							lastConversations: {
								...state.conversations[action.campType][action.conversationId].lastConversations,
								isAllConversations: action.isAllConversations,
								lastIdSearched: action.lastConversationId,
								fetching: false
							}
						}
					)
				};
			} else return state;
		case ACTIONS_FROM_UNIFIED_INBOX.FETCHING_CONVERSATION:
			if(state.conversations && state.conversations[action.campType][action.conversationId]){
				return {
					...state,
					// conversations: {
					// 	...state.conversations,
					// 	[action.conversationId]: {
					// 		...state.conversations[action.conversationId],
					// 		lastConversations: {
					// 			...state.conversations[action.conversationId].lastConversations,
					// 			fetching: action.fetching
					// 		}
					// 	}
					// }
					conversations: getNewDictionary(
						state.conversations, 
						action.campType, 
						action.conversationId, 
						{
							lastConversations: {
								...state.conversations[action.campType][action.conversationId].lastConversations,
								fetching: action.fetching
							}
						}
					)
				};
			} else return state;
		case ACTIONS_FROM_UNIFIED_INBOX.RESET_TIMEOUT:
			if(state.conversations && state.conversations[action.campType][action.conversationId]){
				return{
					...state,
					conversations: getNewDictionary(
						state.conversations, 
						action.campType, 
						action.conversationId, 
						{
							SecTimeOutLastMessageAgent: null
						}
					)
				}
			} else return state;
		case ACTIONS_FROM_UNIFIED_INBOX.UPDATE_PERMISSION:
			if(state.conversations){
				const convsTmp = {};
				for(let campType in state.conversations){
						for(let convId in state.conversations[campType]){
						convsTmp[campType][convId] = {
							...state.conversations[campType][convId],
							allowUnassign: action.permissionName === UNIFIED_INBOX_PERMISSIONS.AllowUnassign ? action.permissionValue : state.conversations[campType][convId].allowUnassign,
							allowSpam: action.permissionName === UNIFIED_INBOX_PERMISSIONS.AllowSpam ? action.permissionValue : state.conversations[campType][convId].allowSpam
						}
					}
				}
				return{
					...state,
					conversations: convsTmp
				}
			}
			return state;
		case ACTIONS_FROM_UNIFIED_INBOX.NEW_DRAFT_MESSAGE:
			return {
				...state,
				draftMessages: {
					...state.draftMessages,
					[action.id]:{
						messageId: action.id,
						data: [
							{
								type: 'paragraph',
								children: [{ text: '', font: 'Arial', size: '14px' }]
							}
						],
						attachments:[]
					}
				}
			};
		case ACTIONS_FROM_UNIFIED_INBOX.UPDATE_DRAFT_MESSAGE:
			return {
				...state,
				draftMessages:{
					...state.draftMessages,
					[action.id]:{
						...state.draftMessages[action.id],
						data: action.data
					}
				}
			};
		case ACTIONS_FROM_UNIFIED_INBOX.UPDATE_DRAFT_ATTACHMENTS:
			return {
				...state,
				draftMessages:{
					...state.draftMessages,
					[action.id]:{
						...state.draftMessages[action.id],
						attachments: action.data
					}
				}
			};
		case ACTIONS_FROM_UNIFIED_INBOX.DELETE_DRAFT_MESSAGE:
			return {
				...state,
				draftMessages:{
					...state.draftMessages,
					[action.id]:{
						...state.draftMessages[action.id],
						data: [
							{
								type: 'paragraph',
								children: [{ text: '', font: 'Arial', size: '14px' }]
							}
						],
						attachments:[]
					}
				}
			};
		case ACTIONS_FROM_UNIFIED_INBOX.UPDATE_CONVERSATIONS_PHONE_CHANGE:
			if(state.conversations && action.conversationIds && action.campType != null){
				const actionConvs = action.conversationIds.split(',');
				const newConvs = {...state.conversations };
				delete newConvs[action.campType];
				newConvs[action.campType] = {};
				for(let key in state.conversations[action.campType]){
					newConvs[action.campType][key] = {
						...state.conversations[action.campType][key],
						disabledUnassign: actionConvs.includes(key)
					}
				}
				return {...state, conversations: newConvs}
			} else return state;
		case ACTIONS_FROM_UNIFIED_INBOX.CHAT_CONVERSATION_READ:
			return {
				...state,
				conversations: getNewDictionary(
					state.conversations,
					action.campType,
					action.id,
					{
						messages: state.conversations[action.campType][action.idConversation].messages.map( v => ({
							...v,
							seen: true
						}))
					}
				)
			};
		default:
			return state;
	}
};

export default unifiedInboxState;

export const endConversation = (data) => ({type: ACTIONS_FROM_UNIFIED_INBOX.END_CONVERSATION, data});


// WEBPACK FOOTER //
// ./src/redux/reducers/reducer_unified_inbox.js